import { router } from '@/routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

/**
 * Styles
 */
import 'antd/dist/reset.css';
import 'overlayscrollbars/overlayscrollbars.css';
import './main.less';

const Main: React.FC<React.PropsWithChildren> = ({ children }) => {
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#0ea5e9',

                    colorBgLayout: '#f3f4f6',
                    colorText: '#1f2937',
                },
            }}
        >
            {children}
        </ConfigProvider>
    );
};

createRoot(document.getElementById('root')!).render(
    <QueryClientProvider client={new QueryClient()}>
        <Main>
            <RouterProvider router={router} />
        </Main>
    </QueryClientProvider>,
);
